export default "__VITE_PUBLIC_ASSET__dfe06b46__"